import { render, staticRenderFns } from "./click-to-edit-dropdown-confirm.vue?vue&type=template&id=bf5ed50c"
import script from "./click-to-edit-dropdown-confirm.vue?vue&type=script&lang=js"
export * from "./click-to-edit-dropdown-confirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports